import React from 'react'
import { Link } from 'react-router-dom'



const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const Footer = (props) => {

    return (
        <footer className="wpo-site-footer">
            {/* Conteneur principal avec navigation */}
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="footer-navigation">
                                <ul className="footer-nav-links">
                                    <li><Link onClick={ClickHandler} to="/">Accueil</Link></li>
                                    <li><Link onClick={ClickHandler} to="/about">À propos</Link></li>
                                    <li><Link onClick={ClickHandler} to="/service">Consultations</Link></li>
                                    <li><Link onClick={ClickHandler} to="/contact">Contact</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Conteneur du bas avec copyright */}
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <p className="copyright">
                                <span>© 2025 </span>
                                <a href="https://apattesegales.be" target="_blank" rel="noopener noreferrer">apattesegales.be</a>
                                <span> - Tous droits réservés | Créé par </span>
                                <a href="https://www.google.com" target="_blank" rel="noopener noreferrer">Spike Agency</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;







